export default function isProd() {
  return typeof window !== "undefined" && (
    window.location.hostname.endsWith("narkoswebben.se") ||
    window.location.hostname.endsWith("anaesthesiaweb.org") ||
    window.location.hostname.includes("narkoswebben-dev.netlify.app")
  )
}
